import {css, StyleSheet} from 'aphrodite';
import 'brace';
import 'brace/mode/json';
import 'brace/theme/github';
import PropTypes from 'prop-types';
import React from 'react';
import AceEditor from 'react-ace';

const linkPropType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
});

interface ConfigureSchemaSpecProps {
  link: {
    value: string;
    onChange: (e: {target: {value: string}}) => void;
  };
  readOnly?: boolean;
}

export function ConfigureSchemaSpec({link, readOnly = false}: ConfigureSchemaSpecProps): JSX.Element {
  return (
    <div className={css(styles.section)}>
      <div className="settingsPageContainer-label">JSON Spec</div>
      <AceEditor
        mode="json"
        theme="github"
        enableBasicAutocompletion={true}
        value={link.value}
        onChange={(newValue) => {
          link.onChange({target: {value: newValue}});
        }}
        readOnly={readOnly}
        width="100%"
      />
    </div>
  );
}

ConfigureSchemaSpec.propTypes = {
  link: linkPropType.isRequired,
  readOnly: PropTypes.bool,
};

const styles = StyleSheet.create({
  section: {
    marginBottom: 30,
  },
});
